import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const CheckEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "your email";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        <div className="w-20 h-20 bg-gradient-to-br from-green-100 to-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-10 h-10 text-green-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-3">
          Check Your Email
        </h2>
        <p className="text-gray-600 mb-2">
          We've sent a verification link to
        </p>
        <p className="text-green-600 font-semibold mb-6">{email}</p>
        <div className="bg-gray-50 rounded-xl p-4 mb-6 text-left">
          <p className="text-sm text-gray-600 mb-2">
            <span className="font-medium text-gray-800">1.</span> Open your email inbox
          </p>
          <p className="text-sm text-gray-600 mb-2">
            <span className="font-medium text-gray-800">2.</span> Click the verification link
          </p>
          <p className="text-sm text-gray-600">
            <span className="font-medium text-gray-800">3.</span> Return here to login
          </p>
        </div>    
        <p className="text-sm text-gray-500 mb-4">
          Didn't receive the email? Check your spam folder         
        </p> 
        <button
          onClick={() => navigate("/account/login")}
          className="w-full py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-semibold rounded-xl hover:from-green-600 hover:to-emerald-700 transition-all duration-200 shadow-lg shadow-green-500/25"
        >
          Return to Login
        </button>
      </div>
    </div>
  );
};

export default CheckEmail;
